import { IListItem, IReferralConfig } from '@nkr/models/index';
import { Col, ControlLabel, FormControl, FormGroup, Glyphicon, Label, Panel, Radio } from 'react-bootstrap';
import { IValidation } from './validation';

interface IProps {
    data: IReferralConfig,
    validation: IValidation,
    dirty: boolean,
    preWorkupLabConfigList: IListItem[],
    onRadioChange: (e: React.FormEvent<Radio & HTMLInputElement>) => void,
    onDataChange: (e: React.FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => void
}

const options = [
    { value: 0, label: '90 days (default)' },
    { value: 1, label: '24 hours' },
    { value: 2, label: '48 hours' },
    { value: 3, label: '72 hours' },
    { value: 7, label: '1 Week' },
];

const miles = [
    { value: 0, label: 'N/A' },
    { value: 50, label: '50 miles' },
    { value: 100, label: '100 miles' },
    { value: 150, label: '150 miles' },
    { value: 200, label: '200 miles' },
    { value: 250, label: '250 miles' },
    { value: 300, label: '300 miles' }
];

const Dash = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>DASH</Panel.Heading>
            <Panel.Body>
                <FormGroup validationState={props.dirty && !props.validation.expireToQueuePostScreening ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>If Screening Complete, Expire to Pending Contact?&nbsp;
                        <Glyphicon glyph='glyphicon glyphicon-question-sign' title='Selecting yes to this question will mean that if a candidate has passed the screening but then passes the limit of days to complete and "expires", we will move them into the pending contact queue instead of ruling them out so that they can be contacted.' /><br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='expireToQueuePostScreening' value={1} checked={props.data.expireToQueuePostScreening != null ? props.data.expireToQueuePostScreening : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='expireToQueuePostScreening' value={0} checked={props.data.expireToQueuePostScreening != null ? !props.data.expireToQueuePostScreening : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.useReducedQuestions ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Reduce Medical History Questions?&nbsp;
                        <Glyphicon glyph='glyphicon glyphicon-question-sign' title='removes questions on: coronary artery disease, stress test, COPD, TB, pneumonia, respiratory issues, gallbladder disease, hep B, hep C, UTI, proteinuria, hematuria, fibroid uterus, endometriosis, PCOS, abortion, obesity history, mammogram, pap smear, and colonoscopy' /><br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='useReducedQuestions' value={1} checked={props.data.useReducedQuestions != null ? props.data.useReducedQuestions : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='useReducedQuestions' value={0} checked={props.data.useReducedQuestions != null ? !props.data.useReducedQuestions : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.askSexualSocialQuestions ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Ask High Risk Social Questions?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='askSexualSocialQuestions' value={1} checked={props.data.askSexualSocialQuestions != null ? props.data.askSexualSocialQuestions : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='askSexualSocialQuestions' value={0} checked={props.data.askSexualSocialQuestions != null ? !props.data.askSexualSocialQuestions : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.askForId ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Ask for Identification Details (SSN or Govt. Issued Id)?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='askForId' value={1} checked={props.data.askForId != null ? props.data.askForId : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='askForId' value={0} checked={props.data.askForId != null ? !props.data.askForId : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.callbackBusinessDays ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Business days for callback?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type="text"
                            id="callbackBusinessDays"
                            value={props.data.callbackBusinessDays}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.dashDonorDaysToExpire ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Days to allow donor to complete history?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={5}>
                        <FormControl
                            componentClass='select'
                            name='dashDonorDaysToExpire'
                            id="dashDonorDaysToExpire"
                            value={props.data.dashDonorDaysToExpire}
                            onChange={props.onDataChange}
                        >
                            {options.map(i =>
                                <option key={'expDays-' + i.value} value={i.value}>{i.label}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>

                {props.data.isDashLiverParticipant && (
                    <FormGroup>
                        <Col xs={12} lg={6} componentClass={ControlLabel}>When available, use Pre-Workup Labs for Liver candidates?<br />
                            <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                                PL DASH
                            </Label>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Radio inline name='dashUsesLiverPwl' value={1} checked={props.data.dashUsesLiverPwl != null ? props.data.dashUsesLiverPwl : false} onChange={props.onRadioChange}>Yes</Radio>
                            <Radio inline name='dashUsesLiverPwl' value={0} checked={props.data.dashUsesLiverPwl != null ? !props.data.dashUsesLiverPwl : false} onChange={props.onRadioChange}>No</Radio>
                        </Col>
                    </FormGroup>
                )}

                <FormGroup validationState={props.dirty && !props.validation.dashUsesPwlQuest ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>When available, use Pre-Workup Labs for Kidney candidates?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='dashUsesPwlQuest' value={1} checked={props.data.dashUsesPwlQuest != null ? props.data.dashUsesPwlQuest : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='dashUsesPwlQuest' value={0} checked={props.data.dashUsesPwlQuest != null ? !props.data.dashUsesPwlQuest : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                {props.data.dashUsesPwlQuest == true && (
                    <div id='pwlConfig'>
                        <FormGroup>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>
                                Utilize Cystatin-C instead of 24-hour jug for PWL<br/>(when available)?
                            </Col>
                            <Col xs={12} md={6}>
                                <Radio inline name='useCystatinC' value={1} checked={props.data.useCystatinC != null ? props.data.useCystatinC : false} onChange={props.onRadioChange}>Yes</Radio>
                                <Radio inline name='useCystatinC' value={0} checked={props.data.useCystatinC != null ? !props.data.useCystatinC : false} onChange={props.onRadioChange}>No</Radio>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} md={6} componentClass={ControlLabel}>
                                Always use PWL for:
                            </Col>
                            <Col xs={12} md={6}>
                                <FormControl
                                    componentClass='select'
                                    name='preWorkupLabConfig'
                                    id="preWorkupLabConfig"
                                    value={props.data.preWorkupLabConfig}
                                    onChange={props.onDataChange}
                                >
                                    {props.preWorkupLabConfigList.map(i =>
                                        <option key={'pre-' + i.id} value={i.id}>{i.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>

                        {props.data.preWorkupLabConfig != 0 && (
                            <FormGroup>
                                <Col xs={12} md={6} componentClass={ControlLabel}>
                                    And for any candidate further than:
                                </Col>
                                <Col xs={12} md={6}>
                                    <FormControl
                                        componentClass='select'
                                        name='dashUsesPwlAtMiles'
                                        id="dashUsesPwlAtMiles"
                                        value={props.data.dashUsesPwlAtMiles}
                                        onChange={props.onDataChange}
                                    >
                                        {miles.map(({ value, label }) => (
                                            <option key={'pwl-miles-' + value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        )}
                    </div>
                )}

                <FormGroup>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Phone number to supply to donor?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type="text"
                            id="plDashPhoneNumber"
                            value={props.data.plDashPhoneNumber}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.plDashPhoneIsDisplayed ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>When available, display phone number:<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='plDashPhoneIsDisplayed' value={1} checked={props.data.plDashPhoneIsDisplayed != null ? props.data.plDashPhoneIsDisplayed : false} onChange={props.onRadioChange}>On Site</Radio>
                        <Radio inline name='plDashPhoneIsDisplayed' value={0} checked={props.data.plDashPhoneIsDisplayed != null ? !props.data.plDashPhoneIsDisplayed : false} onChange={props.onRadioChange}>Emails Only</Radio>
                    </Col>
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default Dash;